<template>
    <div class="flex flex-col sm:flex-row border border-r-0 border-gray-400 bg-white">
        <dashboard-status-tab
            color="green"
            text_color="text-green-500"
            border_color="border-green-400"
            selected_bg="bg-green-100"
            hover_bg="hover:bg-green-100"
            :selected="filter_by_status === 'green'"
            :tally="tally.green"
            @filter="filterByStatus"
        />

        <dashboard-status-tab
            color="yellow"
            text_color="text-yellow-500"
            border_color="border-yellow-500"
            selected_bg="bg-yellow-100"
            hover_bg="hover:bg-yellow-100"
            :selected="filter_by_status === 'yellow'"
            :tally="tally.yellow"
            @filter="filterByStatus"
        />

        <dashboard-status-tab
            color="red"
            text_color="text-red-600"
            border_color="border-red-600"
            selected_bg="bg-red-100"
            hover_bg="hover:bg-red-100"
            :selected="filter_by_status === 'red'"
            :tally="tally.red"
            @filter="filterByStatus"
        />
    </div>
</template>

<script>
import DashboardStatusTab from './dashboard-status-tab.vue';

export default {
    components: {
        DashboardStatusTab,
    },

    props: {
        tally: {},
        filter_by_status: {},
    },

    methods: {
        filterByStatus(color) {
            this.$emit('filter', color);
        },
    },
}
</script>
